








































import { Component, Vue } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import '@/types';
// import machineryProfilesRepository from '@/services/contactsRepository';
// import notificationService from '@/services/notificationService';
// import documentModal from '@/components/defaultPopups/documentModal.vue';
import MachineryProfile from '@/modules/machinery/classes/MachineryProfile';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
// import contractsRepository from '@/services/projects/contractsRepository';
// import DataSource from 'devextreme/data/data_source';
// import dxCustomStore from 'devextreme/data/custom_store';
import _ from 'lodash';
import cDatagrid from '@/components/default/Datagrid.vue';
// import settings from '@/settings.json';
import SavedBar from '@/components/default/SavedBar.vue';
import machineryProfilesRepository from '@/modules/machinery/services/machineryProfilesRepository';

Component.registerHooks([
    'beforeRouteLeave',
]);

@Component({
  components: {
    cCard,
    // documentModal,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    cDatagrid,
    SavedBar,
  },
})
export default class MachineryProfileDetailPage extends Vue {
  private profile: MachineryProfile = new MachineryProfile();

  private saveDebounced: any = _.debounce(() => {
    this.profile.save();
  }, 3000);

  private save() {
    this.profile.dirty = true;
    this.saveDebounced();
  }

  private async mounted() {
    this.profile.init(this.$route.params.id);
  }

  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.profile.dirty) {
      if (confirm('Er zijn onopgeslagen wijzigingen. Bent u zeker dat u wenst te veranderen van pagina?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  get fieldTypeOptions() {
    return machineryProfilesRepository.getFieldTypes();
  }

  get columns() {
    return [
      {
        dataField: 'name',
        caption: 'Naam',
        validationRules: [
          {type: 'required', message: 'Veld is verplicht'},
        ],
      },
      {
        dataField: 'type',
        caption: 'Type',
        lookup: {
          dataSource: machineryProfilesRepository.getFieldTypes(),
          valueExpr: 'value',
          displayExpr: 'text',
        },
        validationRules: [
          {type: 'required', message: 'Veld is verplicht'},
        ],
      },
      {
        dataField: 'required',
        caption: 'Verplicht',
        dataType: 'boolean',
      },
      {
        type: 'buttons',
        buttons: [
          'edit',
          'delete',
        ],
      },
    ];
  }
}
